import { NuorderOrderingState } from 'root/apps/PurchaseOrder/NuorderOrdering/context/Context';
import { ItemVendorNum, PurchaseLine } from 'root/apps/PurchaseOrder/NuorderOrdering/types';

export const updateStateItemVendorNum = (
  items: NuorderOrderingState['items'],
  itemID: number,
  vendorID: number,
  itemVendorNum: ItemVendorNum | null
): NuorderOrderingState['items'] => {
  if (!items) return items;
  const item = items[itemID];
  if (!item) return items;

  if (!itemVendorNum) {
    return {
      ...items,
      [itemID]: {
        ...item,
        ItemVendorNums: item.ItemVendorNums.filter((num) => num.vendorID !== vendorID),
      },
    };
  }

  const updatedItem = {
    ...item,
    ItemVendorNums: [
      ...item.ItemVendorNums.filter((itemVendorNum) => itemVendorNum.vendorID !== vendorID),
      itemVendorNum,
    ],
  };

  return {
    ...items,
    [itemID]: updatedItem,
  };
};

export const updateStatePurchaseLine = (
  purchaseLines: NuorderOrderingState['purchaseLines'],
  purchaseLine: PurchaseLine
): NuorderOrderingState['purchaseLines'] => {
  if (!purchaseLines) return purchaseLines;
  const index = purchaseLines.findIndex((line) => line.orderLineID === purchaseLine.orderLineID);
  if (index === -1) return purchaseLines;

  const updatedPurchaseLines = [...purchaseLines];
  updatedPurchaseLines[index] = purchaseLine;

  return updatedPurchaseLines;
};

export const deleteStatePurchaseLine = (
  purchaseLines: NuorderOrderingState['purchaseLines'],
  purchaseLineID: number
): NuorderOrderingState['purchaseLines'] => {
  if (!purchaseLines) return purchaseLines;
  const index = purchaseLines.findIndex((line) => line.orderLineID === purchaseLineID);
  if (index === -1) return purchaseLines;

  const updatedPurchaseLines = [...purchaseLines];
  updatedPurchaseLines.splice(index, 1);

  return updatedPurchaseLines;
};
